<template>
  <el-container>
    <Header pageName="充值记录"></Header>
    <el-main>
      <el-form class="el-form-search" label-width="100px">
        <el-form-item label="充值店铺：">
          <el-select v-model="searchForm.uniacid" size="small" filterable placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in shopList" :key="index" :label="item.name" :value="item.uniacid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值时间：">
          <el-date-picker
            v-model="searchForm.starttime"
            size="small"
            type="daterange"
            value-format="timestamp"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label=" " label-width="20px">
          <el-button type="primary" size="small" @click="search">搜索</el-button>
          <el-button plain size="small" @click="cancelSearch">清空搜索条件</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="list" :header-cell-style="{ 'background-color': '#F8F9FA' }" row-key="id">
        <template slot="empty">
          <No />
        </template>
        <el-table-column prop="create_time" label="充值时间" align="center">
          <template v-slot="{ row }">{{ getDateformat(row.create_time) }}</template>
        </el-table-column>
        <el-table-column prop="account_name" label="充值店铺" align="center"></el-table-column>
        <el-table-column prop="price" label="充值金额" align="center"></el-table-column>
        <el-table-column prop="from_text" label="充值类目" align="center"></el-table-column>
      </el-table>
      <Paging :total="total" :page="searchForm.page" :pageNum="searchForm.rows" @updatePageNum="updateData"></Paging>
    </el-main>
  </el-container>
</template>

<script>
import { getDateformat } from '@/util/getDate';
import Header from './components/header';
import Paging from '@/components/paging';
export default {
  components: {
    Header,
    Paging,
  },
  data() {
    return {
      searchForm: {
        page: 1,
        rows: 10,
        uniacid: '',
        starttime: '',
        endtime: '',
      },
      total: 0,
      list: [],
      shopList: [],
    };
  },
  created() {
    this.getList();
    this.getShopList();
  },
  methods: {
    getDateformat(val) {
      return getDateformat(val);
    },
    updateData(val, status) {
      if (status == 0) {
        this.searchForm.rows = val;
      } else {
        this.searchForm.page = val;
      }
      this.getList();
    },
    search() {
      this.searchForm.page = 1;
      this.getList();
    },
    cancelSearch() {
      this.searchForm = {
        page: 1,
        rows: 10,
        uniacid: '',
        starttime: '',
        endtime: '',
      };
      this.getList();
    },
    getList() {
      let searchForm = Object.assign({}, this.searchForm);
      let data = {
        page: searchForm.page,
        rows: searchForm.rows,
        uniacid: searchForm.uniacid,
      };
      if (searchForm.starttime) {
        data.starttime = searchForm.starttime[0] / 1000;
        data.endtime = searchForm.starttime[1] / 1000;
      }
      this.$axios.post(this.$api.admin.rechargeLog, data).then(res => {
        if (res.code == 0) {
          this.list = res.result.list;
          this.total = res.result.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getShopList() {
      this.$axios.post(this.$api.user.getAccountList, { pagesize: 10000 }).then(res => {
        if (res.code == 0) {
          this.shopList = res.result.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-container {
  flex-direction: column;
  .el-main {
    background: #fff;
    .el-form {
      margin-top: 10px;
    }
  }
}
</style>